import { render, staticRenderFns } from "./look.vue?vue&type=template&id=dec2a4a4&scoped=true&"
import script from "./look.vue?vue&type=script&lang=js&"
export * from "./look.vue?vue&type=script&lang=js&"
import style0 from "./look.vue?vue&type=style&index=0&id=dec2a4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec2a4a4",
  null
  
)

component.options.__file = "look.vue"
export default component.exports